"use strict";var typography={sans:["Roboto","sans-serif"],serif:["Roboto Slab","serif"],body:["Roboto","sans-serif"]};module.exports=typography;